module.exports = __webpack_public_path__ + "img/productSatellite_26.644b97d4.png";